import { MappedEntity } from '~/shared/hooks/use-entities';

export const isEntityFromUS = (entity: Pick<MappedEntity, 'country'>) =>
  entity.country?.long.toLowerCase() === 'us';
